import axios from "axios";
import styles from './friends.module.css';
import { useEffect, useState } from "react";
import { getNotif } from "../Utils/GetNotif";
import { API_URL } from '../Utils/api';
import { FaUserCheck, FaUserPlus } from "react-icons/fa";

export const Friend = ({ authorId, setRefresh, refresh }) => {
  const [followings, setFollowings] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [amis, setAmis] = useState([]);
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  // Récupérer les followings de l'utilisateur
  useEffect(() => {
    const fetchFollowings = async () => {
      try {
        const followingResponse = await axios.get(`${API_URL}/following`, {
          headers: { Authorization: `Bearer${token}` }
        });
        setFollowings(followingResponse.data || []);
      } catch (err) {
        console.error('Erreur fetch followings:', err);
      }
      try {
        const folllowersResponse = await axios.get(`${API_URL}/followers`, {
          headers: { Authorization: `Bearer${token}` }
        });
        setFollowers(folllowersResponse.data || []);
      } catch (err) {
        console.error('Erreur fetch followings:', err);
      }
      try {
        const folllowersResponse = await axios.get(`${API_URL}/amis`, {
          headers: { Authorization: `Bearer${token}` }
        });
        setAmis(folllowersResponse.data || []);
      } catch (err) {
        console.error('Erreur fetch followings:', err);
      }
    };
    fetchFollowings();
  }, [token, refresh]);

  const handleFollow = async () => {
    try {
      const response = await axios.put(
        `${API_URL}/follow`,
        { authorId },
        { headers: { Authorization: `Bearer${token}` } }
      );

      if (!isFollowing) {
        getNotif({ userId, authorId, message: "a commencé à vous suivre", type: 'follow', token });
      }
      setFollowings(response.data.userFollowings || []);
      setRefresh(prev => !prev);
    } catch (err) {
      console.error('Erreur : ', err);
    }
  };

  const handleBackFollow = async () => {
    try {
      const response = await axios.put(
        `${API_URL}/back_follow`,
        { authorId },
        { headers: { Authorization: `Bearer${token}` } }
      );
      setAmis(response.data.userFollowings || []);

      if (!isFollowed) {
        getNotif({ userId, authorId, message: "a commencé à vous suivre", type: 'follow', token });
      }
      setRefresh(prev => !prev);
    } catch (err) {
      console.error('Erreur : ', err);
    }
  };

  if (authorId === userId) return null;

  const isFollowing = followings.includes(authorId);
  const isFollowed = followers.includes(authorId);
  const isFriends = amis.includes(authorId);

  return (
    <>
      {!isFriends&& <button
        className={isFollowing ? styles.followingBtn : styles.followBtn}
        onClick={handleFollow}
      >
        {isFollowing ? <FaUserCheck/> : <FaUserPlus/>}
      
      </button>}

      {isFriends &&<button className={isFriends?styles.followingBtn: 'hidden'}>Ami(e)</button>}
      
    </>
  );
};
